import {
  ListenerItemAttributes,
  ListenerItemKlass,
  ListenerItemResourcesType,
  PlayerListenerItemInterface
} from '@splixer/common';
import { AnyHash, Uuid } from '@hidat/huijs-common';
import { Expose, Transform, Type } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';
import * as dayjs from 'dayjs';

export class PlayerListenerItem implements PlayerListenerItemInterface {
  @Expose({ name: 'id' })
  id: Uuid | undefined;
  @Expose({ name: 'resource_type' })
  resourceType: ListenerItemResourcesType | undefined;
  @Expose({ name: 'resource_uid' })
  resourceUid: Uuid | undefined;
  @Expose({ name: 'external_content_url' })
  externalContentUrl: string | undefined;
  @Expose({ name: 'item_klass' })
  itemKlass: ListenerItemKlass | undefined;
  @Expose({ name: 'tags' })
  tags: string | undefined;
  @Expose({ name: 'item_attributes' })
  itemAttributes: ListenerItemAttributes | undefined;
  @Expose({ name: 'count' })
  count: number | undefined;
  @Expose({ name: 'subscription_status' })
  subscriptionStatus: number | undefined;
  @Expose({ name: 'review_status' })
  reviewStatus: number | undefined;
  @Expose({ name: 'reviewed_on' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  reviewedOn: dayjs.Dayjs | undefined;
  @Expose({ name: 'created_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined;


  @Expose({ name: '_resource' })
  /*
  @Type(() => ListenerItemResourcesType, {
    discriminator: {
      property: 'resourceType',
      subTypes: [
        { value: PlayerProgramBase, name: 'Program' },
      ],
    }|
  })*/
  _resource: AnyHash | undefined;
}
